import { IPropertyAddressData } from '../../address/IPropertyAddressData';
import { ICountyResponse } from '../../../ui-toolkit/orders/searchOrder/types/ICounty';

export interface IClientOrderAddressResponse {
  street_address: string;
  unit?: string;
  city: string;
  state_abbreviation: string;
  zip_code: string;
  //not clear which field will be returned by BE
  county_name?: string;
  county?: ICountyResponse;
}

export const convertIClientOrderAddressResponseToIPropertyAddressData = ({
  street_address,
  state_abbreviation,
  zip_code,
  county_name,
  county,
  ...rest
}: IClientOrderAddressResponse): IPropertyAddressData => ({
  id: '',
  streetAddress: street_address,
  stateAbbreviation: state_abbreviation,
  zipCode: zip_code,
  createdAt: '',
  updatedAt: '',
  ...rest,
});

export const convertIPropertyAddressDataToIClientOrderAddressResponse = ({
  streetAddress,
  stateAbbreviation,
  unit,
  city,
  zipCode,
}: IPropertyAddressData): IClientOrderAddressResponse => ({
  street_address: streetAddress,
  state_abbreviation: stateAbbreviation,
  unit: unit,
  city: city,
  zip_code: zipCode,
});
